import { KeywordProperties } from '../combined.flow.adapter';
import { SupportedSearchKeywords } from '../../../providers/atweb-query-expression-parser.service';

export class UserAdapterMapper {
  // compared to default logic, these two methods swap the meaning of 'src/dst' for user and site fields

  static populateIncoming(keywordsToIncoming: Map<string, KeywordProperties>) {
    keywordsToIncoming.set(SupportedSearchKeywords.App, { placement: 'no-alias', fieldName: 'app' });
    keywordsToIncoming.set(SupportedSearchKeywords.Server, { placement: 'no-alias', fieldName: 'serverip' });
    keywordsToIncoming.set(SupportedSearchKeywords.Site, { placement: 'src', fieldPrefix: 'site', alias: 'site_src', fieldName: 'site1' });
    keywordsToIncoming.set(SupportedSearchKeywords.User, { placement: 'dst', fieldPrefix: 'user', alias: 'user_dst', fieldName: 'user2' });
    // we might need to add here IP and DNS. But to do that right, we need a real use case
  }

  static populateOutgoing(keywordsToOutgoing) {
    keywordsToOutgoing.set(SupportedSearchKeywords.App, { placement: 'no-alias', fieldName: 'app' });
    keywordsToOutgoing.set(SupportedSearchKeywords.Server, { placement: 'no-alias', fieldName: 'serverip' });
    keywordsToOutgoing.set(SupportedSearchKeywords.Site, { placement: 'dst', fieldPrefix: 'site', alias: 'site_dst', fieldName: 'site2' });
    keywordsToOutgoing.set(SupportedSearchKeywords.User, { placement: 'src', fieldPrefix: 'user', alias: 'user_src', fieldName: 'user1' });
    // we might need to add here IP and DNS. But to do that right, we need a real use case
  }
}
